import { render, staticRenderFns } from "./EdYoutubeDestination.vue?vue&type=template&id=63290ee8&"
import script from "./EdYoutubeDestination.vue?vue&type=script&lang=js&"
export * from "./EdYoutubeDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports